import { render, staticRenderFns } from "./DashboardAsset.vue?vue&type=template&id=13d841a5&"
import script from "./DashboardAsset.vue?vue&type=script&lang=js&"
export * from "./DashboardAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports